// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════
   Custom Country-Code Select
   — image flags via flagcdn.com
   — clean pill trigger + searchable dropdown
══════════════════════════════════════════ */

.custom-country-select-container {
  position: relative;
  width: 116px;
  flex-shrink: 0;
}

/* ── Trigger button ── */
.custom-country-select-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  height: 48px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 0 10px;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  transition: background-color 0.18s ease, border-color 0.18s ease;
  overflow: hidden;
}

.custom-country-select-trigger:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.custom-country-select-trigger.active,
.custom-country-select-trigger:focus-visible {
  border-color: #2a71ff;
  background-color: #ffffff;
  box-shadow: 0 0 0 2.5px rgba(42, 113, 255, 0.15);
}

/* Flag image in trigger */
.ccs-flag-img {
  display: block;
  width: 20px;
  height: 15px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.08);
}

/* Emoji fallback in trigger */
.ccs-flag-emoji {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
}

/* Dial code */
.ccs-code {
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Chevron */
.ccs-chevron {
  width: 11px;
  height: 11px;
  color: #94a3b8;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.ccs-chevron--open {
  transform: rotate(180deg);
}

/* ── Dropdown panel ── */
.custom-country-select-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 290px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow:
    0 16px 40px -8px rgba(15, 23, 42, 0.14),
    0 4px 10px -2px rgba(15, 23, 42, 0.07);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ccs-dropdown-in 0.14s cubic-bezier(0.22,1,0.36,1);
}

@keyframes ccs-dropdown-in {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* ── Search bar ── */
.custom-country-search-wrapper {
  padding: 8px 8px 7px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ccs-search-icon {
  color: #94a3b8;
  flex-shrink: 0;
}

.custom-country-search-input {
  flex: 1;
  height: 34px;
  padding: 0 8px;
  font-size: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  background: #f8fafc;
  color: #334155;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.custom-country-search-input:focus {
  border-color: #2a71ff;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(42,113,255,0.10);
}
.custom-country-search-input::placeholder {
  color: #94a3b8;
}

/* ── Options list ── */
.custom-country-options-list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 224px;
  overflow-y: auto;
}

/* Slim scrollbar */
.custom-country-options-list::-webkit-scrollbar { width: 4px; }
.custom-country-options-list::-webkit-scrollbar-track { background: transparent; }
.custom-country-options-list::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
.custom-country-options-list::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

/* ── Option row ── */
.custom-country-option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  cursor: pointer;
  transition: background-color 0.1s ease;
}
.custom-country-option-item:hover {
  background-color: #f1f5f9;
}
.custom-country-option-item.country-selected {
  background-color: #f0f7ff;
}

/* Flag image in option */
.ccs-opt-flag-img {
  display: block;
  width: 20px;
  height: 15px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.08);
}

/* Emoji flag fallback in option */
.ccs-opt-flag-emoji {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
}

/* Placeholder when no flag */
.ccs-opt-flag-placeholder {
  width: 20px;
  height: 15px;
  flex-shrink: 0;
  border-radius: 2px;
  background: #f1f5f9;
}

/* Dial code pill */
.ccs-opt-code {
  font-size: 0.75rem;
  font-weight: 600;
  color: #2a71ff;
  background: #eff6ff;
  border-radius: 5px;
  padding: 1px 5px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* Country name */
.ccs-opt-name {
  flex: 1;
  min-width: 0;
  font-size: 0.8rem;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Checkmark */
.ccs-check-icon {
  flex-shrink: 0;
  margin-left: auto;
}

/* No results */
.custom-country-no-options {
  padding: 12px;
  font-size: 0.8rem;
  color: #64748b;
  text-align: center;
}

/* ── Dark mode ── */
.dark .custom-country-select-trigger {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .custom-country-select-trigger:hover {
  background-color: #253347;
}
.dark .ccs-code { color: #e2e8f0; }
.dark .custom-country-select-dropdown {
  background-color: #1e293b;
  border-color: #334155;
  box-shadow: 0 16px 40px -8px rgba(0,0,0,0.4);
}
.dark .custom-country-search-wrapper { border-color: #334155; background: #1e293b; }
.dark .custom-country-search-input   { background: #0f172a; border-color: #334155; color: #e2e8f0; }
.dark .custom-country-option-item         { color: #e2e8f0; }
.dark .custom-country-option-item:hover   { background: #253347; }
.dark .custom-country-option-item.country-selected { background: #1e3a5f; }
.dark .ccs-opt-name  { color: #cbd5e1; }
.dark .ccs-opt-code  { background: #1e3a5f; color: #60a5fa; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CartAddCustomer/CustomCountryCodeSelect.css"],"names":[],"mappings":"AAAA;;;;4CAI4C;;AAE5C;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB;;0CAEwC;EACxC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB,kDAAkD,UAAU,EAAE;AAC9D,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,mBAAmB,EAAE,kBAAkB,EAAE;AACjG,8DAA8D,mBAAmB,EAAE;;AAEnF,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA,kBAAkB,cAAc,EAAE;AAClC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;AACA,uCAAuC,qBAAqB,EAAE,mBAAmB,EAAE;AACnF,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnG,4CAA4C,cAAc,EAAE;AAC5D,4CAA4C,mBAAmB,EAAE;AACjE,qDAAqD,mBAAmB,EAAE;AAC1E,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════\n   Custom Country-Code Select\n   — image flags via flagcdn.com\n   — clean pill trigger + searchable dropdown\n══════════════════════════════════════════ */\n\n.custom-country-select-container {\n  position: relative;\n  width: 116px;\n  flex-shrink: 0;\n}\n\n/* ── Trigger button ── */\n.custom-country-select-trigger {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  height: 48px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  padding: 0 10px;\n  cursor: pointer;\n  outline: none;\n  box-sizing: border-box;\n  transition: background-color 0.18s ease, border-color 0.18s ease;\n  overflow: hidden;\n}\n\n.custom-country-select-trigger:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.custom-country-select-trigger.active,\n.custom-country-select-trigger:focus-visible {\n  border-color: #2a71ff;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 2.5px rgba(42, 113, 255, 0.15);\n}\n\n/* Flag image in trigger */\n.ccs-flag-img {\n  display: block;\n  width: 20px;\n  height: 15px;\n  object-fit: cover;\n  border-radius: 2px;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.08);\n}\n\n/* Emoji fallback in trigger */\n.ccs-flag-emoji {\n  font-size: 1.1rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n/* Dial code */\n.ccs-code {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #334155;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Chevron */\n.ccs-chevron {\n  width: 11px;\n  height: 11px;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n.ccs-chevron--open {\n  transform: rotate(180deg);\n}\n\n/* ── Dropdown panel ── */\n.custom-country-select-dropdown {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  width: 290px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow:\n    0 16px 40px -8px rgba(15, 23, 42, 0.14),\n    0 4px 10px -2px rgba(15, 23, 42, 0.07);\n  z-index: 9999;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: ccs-dropdown-in 0.14s cubic-bezier(0.22,1,0.36,1);\n}\n\n@keyframes ccs-dropdown-in {\n  from { opacity: 0; transform: translateY(-6px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0)    scale(1); }\n}\n\n/* ── Search bar ── */\n.custom-country-search-wrapper {\n  padding: 8px 8px 7px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ccs-search-icon {\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.custom-country-search-input {\n  flex: 1;\n  height: 34px;\n  padding: 0 8px;\n  font-size: 0.8rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  outline: none;\n  background: #f8fafc;\n  color: #334155;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.custom-country-search-input:focus {\n  border-color: #2a71ff;\n  background: #ffffff;\n  box-shadow: 0 0 0 2px rgba(42,113,255,0.10);\n}\n.custom-country-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* ── Options list ── */\n.custom-country-options-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  max-height: 224px;\n  overflow-y: auto;\n}\n\n/* Slim scrollbar */\n.custom-country-options-list::-webkit-scrollbar { width: 4px; }\n.custom-country-options-list::-webkit-scrollbar-track { background: transparent; }\n.custom-country-options-list::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }\n.custom-country-options-list::-webkit-scrollbar-thumb:hover { background: #94a3b8; }\n\n/* ── Option row ── */\n.custom-country-option-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n}\n.custom-country-option-item:hover {\n  background-color: #f1f5f9;\n}\n.custom-country-option-item.country-selected {\n  background-color: #f0f7ff;\n}\n\n/* Flag image in option */\n.ccs-opt-flag-img {\n  display: block;\n  width: 20px;\n  height: 15px;\n  object-fit: cover;\n  border-radius: 2px;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.08);\n}\n\n/* Emoji flag fallback in option */\n.ccs-opt-flag-emoji {\n  font-size: 1.1rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n/* Placeholder when no flag */\n.ccs-opt-flag-placeholder {\n  width: 20px;\n  height: 15px;\n  flex-shrink: 0;\n  border-radius: 2px;\n  background: #f1f5f9;\n}\n\n/* Dial code pill */\n.ccs-opt-code {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #2a71ff;\n  background: #eff6ff;\n  border-radius: 5px;\n  padding: 1px 5px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n/* Country name */\n.ccs-opt-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.8rem;\n  color: #334155;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Checkmark */\n.ccs-check-icon {\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n/* No results */\n.custom-country-no-options {\n  padding: 12px;\n  font-size: 0.8rem;\n  color: #64748b;\n  text-align: center;\n}\n\n/* ── Dark mode ── */\n.dark .custom-country-select-trigger {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .custom-country-select-trigger:hover {\n  background-color: #253347;\n}\n.dark .ccs-code { color: #e2e8f0; }\n.dark .custom-country-select-dropdown {\n  background-color: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 16px 40px -8px rgba(0,0,0,0.4);\n}\n.dark .custom-country-search-wrapper { border-color: #334155; background: #1e293b; }\n.dark .custom-country-search-input   { background: #0f172a; border-color: #334155; color: #e2e8f0; }\n.dark .custom-country-option-item         { color: #e2e8f0; }\n.dark .custom-country-option-item:hover   { background: #253347; }\n.dark .custom-country-option-item.country-selected { background: #1e3a5f; }\n.dark .ccs-opt-name  { color: #cbd5e1; }\n.dark .ccs-opt-code  { background: #1e3a5f; color: #60a5fa; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
